// extracted by mini-css-extract-plugin
export var collapsible_wrapper = "collapsible_wrapper-PP6";
export var collapsible_wrapper_open = "collapsible_wrapper_open-CtU";
export var content_wrap = "content_wrap-c-x";
export var trigger_icon = "trigger_icon-7Gs";
export var trigger_icon_open = "trigger_icon_open-1b6";
export var trigger_label = "trigger_label-D5m";
export var trigger_label_open = "trigger_label_open-mwr";
export var trigger_wrapper = "trigger_wrapper-Uu6";